import { lazy } from "../../helpers/lazy";
import GtmService from "../apps/services/gtm.service";

export default class PromotionTracking {
    private root: HTMLElement;
    private name: string;
    private id: string;
    private slot: string;
    private links: HTMLCollectionOf<HTMLAnchorElement>;

    constructor(element: HTMLElement) {
        this.root = element;
        this.name = element.dataset.name || '';
        this.id = element.dataset.id || '';
        this.slot = element.dataset.slot || this.name;
        this.init();
    }
    
    init = () => {
        this.links = this.root.getElementsByTagName('a');
        this.setupViewPromotionTracking();
        this.setupSelectPromotionTracking();
    };

    private setupViewPromotionTracking = () => {
        lazy(() => this.ViewPromotion(), this.root, true);
    }

    private setupSelectPromotionTracking = () => {
        Array.from(this.links)?.forEach((link) => {
            link.addEventListener('click', () => this.SelectPromotion(link));
        });
    }

    private isTile = () => Boolean(this.root.dataset.slot);

    private linkLabel = (link: HTMLAnchorElement) => {
        const text = (link.textContent || '').replace(/\s+/g, ' ').trim();
        if (text) return text;

        try {
            return new URL(link.href, window.location.href).pathname || link.href;
        } catch {
            return link.href;
        }
    };

    private promotionNameForLink = (link: HTMLAnchorElement) => {
        const blockName = this.slot || this.name;
        const label = this.linkLabel(link);
        return label ? `${blockName}-${label}` : blockName;
    };

    private pushView = (promotionName: string, creativeSlot: string) => {
        GtmService.pushViewPromotionEvent(
            this.id,
            creativeSlot,
            false,
            undefined,
            promotionName,
            promotionName
        );
    };

    private ViewPromotion = () => {
        if (!this.isTile()) {
            this.pushView(this.name, this.slot);
            return;
        }

        const links = Array.from(this.links);
        if (!links.length) {
            this.pushView(this.name, this.slot);
            return;
        }

        links.forEach((link) => {
            const promotionName = this.promotionNameForLink(link);
            this.pushView(promotionName, promotionName);
        });
    };
    
    private SelectPromotion = (link: HTMLAnchorElement) => {
        const promotionName = this.isTile() ? this.promotionNameForLink(link) : this.name;
        const creativeSlot = this.isTile() ? promotionName : this.slot;
        GtmService.pushSelectPromotionEvent(
            this.id,
            creativeSlot,
            false,
            undefined,
            link.href,
            promotionName,
            promotionName
        );
    }
}